// AUDITORIA-CLINICA-REDISENO -- iconos SVG en línea (trazo 1.8, 15-18px).
// Sin emojis y sin dependencia nueva: la app ya trae @ant-design/icons, pero
// estos son parte del dibujo de la pantalla (tamaños y trazo propios) y viven
// junto a ella. `currentColor` para que hereden el color del contexto.

const base = (size) => ({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true",
    focusable: "false",
});

export const IconoFlechaIzquierda = ({ size = 16 }) => (
    <svg {...base(size)}>
        <path d="M15 18l-6-6 6-6" />
    </svg>
);

export const IconoFlechaDerecha = ({ size = 16 }) => (
    <svg {...base(size)}>
        <path d="M9 6l6 6-6 6" />
    </svg>
);

export const IconoLapiz = ({ size = 15 }) => (
    <svg {...base(size)}>
        <path d="M4 20h4l10-10a2.1 2.1 0 0 0-3-3L5 17v3z" />
        <path d="M14.5 6.5l3 3" />
    </svg>
);

export const IconoCheck = ({ size = 15 }) => (
    <svg {...base(size)}>
        <path d="M20 6L9 17l-5-5" />
    </svg>
);

export const IconoEscudo = ({ size = 16 }) => (
    <svg {...base(size)}>
        <path d="M12 3l7 3v5c0 4.4-2.9 8.2-7 10-4.1-1.8-7-5.6-7-10V6l7-3z" />
        <path d="M9.5 12l1.8 1.8L15 10" />
    </svg>
);

export const IconoHistorial = ({ size = 16 }) => (
    <svg {...base(size)}>
        <path d="M3.5 12a8.5 8.5 0 1 0 2.6-6.1" />
        <path d="M3.5 4.5V9H8" />
        <path d="M12 7.5V12l3 1.8" />
    </svg>
);

export const IconoAlerta = ({ size = 16 }) => (
    <svg {...base(size)}>
        <path d="M12 4l8.5 15h-17L12 4z" />
        <path d="M12 10v4" />
        <path d="M12 17h.01" />
    </svg>
);

export const IconoInfo = ({ size = 16 }) => (
    <svg {...base(size)}>
        <circle cx="12" cy="12" r="8.5" />
        <path d="M12 11v5" />
        <path d="M12 8h.01" />
    </svg>
);
